// extracted by mini-css-extract-plugin
module.exports = {"socialMediaLink":"SocialMediaLinks-module--socialMediaLink--3MCNv"};